import { render, staticRenderFns } from "./RepRegistrationHeader.vue?vue&type=template&id=55822ff8"
import script from "./RepRegistrationHeader.vue?vue&type=script&lang=js"
export * from "./RepRegistrationHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports